import { APITypes } from '@streem/api';
import { UserInfo } from '@streem/sdk-core';
import { generateUuid } from '@streem/toolbox';
import { TranscriptItemData } from '@streem/ui-react';

type SpeakerMap = {
    [effectiveSpeakerId: string]: {
        userName: string;
        avatarUrl: string | undefined;
    };
};

export type TranscriptBlock = TranscriptItemData & {
    // make required
    startTimeMs: number;
};

export function convertTranscriptionSegmentsToBlocks(
    segments: APITypes.StreemApiArtifactTranscriptionSegment[],
    users: UserInfo[],
): TranscriptBlock[] {
    const speakerNameMap: SpeakerMap = {};

    return segments.map((segment, index) => {
        // there are times when AWS Transcribe does not populate either speakerSid or unknownSpeakerId
        //     In that case, create a unique identifier for the segment.
        const speakerId = segment.speakerSid ?? segment.unknownSpeakerId ?? generateUuid();

        // if have not looked up this speaker id before, look them up
        if (!speakerNameMap[speakerId]) {
            const user = users.find(user => user.id === speakerId);
            const avatarUrl: string | undefined = user?.photoURL;
            const userName: string = user?.name ?? 'Unknown Speaker';

            speakerNameMap[speakerId] = { userName, avatarUrl };
        }

        const { userName, avatarUrl } = speakerNameMap[speakerId];

        return {
            id: index,
            startTimeMs: segment.startTimeMs || 0,
            endTimeMs: segment.endTimeMs || 0,
            speakerName: userName,
            text: segment.text || '',
            avatarUrl,
        };
    });
}
